module.exports = __webpack_public_path__ + "media/images/logos/logotype_white-04066a9fee946a00222be39f137a88b1.svg";